module.exports = __webpack_public_path__ + "img/port_avatar.124cb91d.webp";